module.exports = __webpack_public_path__ + "static/media/shape-s.80998094.png";